<script lang="ts">
import { ref, watch } from 'vue'
import placeholderImg from '@/assets/icons/productPlaceholder.svg'

const IMAGE_PLACEHOLDER_PATH = placeholderImg
</script>

<script lang="ts" setup>
const props = defineProps({
    src: {
        type: String,
        default: IMAGE_PLACEHOLDER_PATH,
    },
    alt: {
        type: String,
        default: '',
    },
    ariaLabel: {
        type: String,
        default: '',
    },
    loadingImage: {
        type: Boolean,
        default: false,
    },
    defaultImgSrc: {
        type: String,
        default: IMAGE_PLACEHOLDER_PATH,
    },
    imgClass: {
        type: [String, Array],
        default: '',
    },
})

const imgUrl = ref(props.src)

watch(
    () => props.src,
    () => {
        if (props.src) {
            imgUrl.value = props.src
        } else {
            imgUrl.value = props.defaultImgSrc
        }
    },
)

function changeToDefaultSrc() {
    imgUrl.value = IMAGE_PLACEHOLDER_PATH
}
</script>

<!-- eslint-disable vue/no-unused-refs -->
<template>
    <transition
        name="t-fade"
        mode="out-in"
    >
        <slot
            v-if="loadingImage"
            name="loading-placeholder"
        />
        <img
            v-else
            ref="img"
            :src="imgUrl"
            :alt="alt"
            :aria-label="ariaLabel"
            loading="lazy"
            :class="imgClass"
            @error="changeToDefaultSrc"
        />
    </transition>
</template>

<style scoped lang="scss">
.t-fade-enter-active,
.t-fade-leave-active {
    --t-fade-duration: 0.15s;
}
</style>
